<template>
  <el-dialog
      title="选择采购账号"
      :visible.sync="visible"
      center
      @close="handlerCancel"
      class="custom-el-wrapper"
  >
    <el-select v-model="current_id" placeholder="请选择采购账号" class="w-full">
      <template v-if="ali_order_type < 1">
        <el-option v-for="item in list" :label="item.phone + '    '+( item.name ?? '' )" :value="item.id" :key="item.id" v-if="item.type == 1"></el-option>
      </template>
      <template v-if="ali_order_type > 0">
        <el-option v-for="item in list" :label="item.phone + '    '+( item.name ?? '' )" :value="item.id" :key="item.id" v-if="item.type == 2"></el-option>
      </template>
    </el-select>
    <el-radio-group v-model="buy_mode" class="w-full mt-3" v-if="ali_order_type < 1 ">
      <el-radio :label="1">普通模式</el-radio>
      <el-radio :label="2">高效模式</el-radio>
    </el-radio-group>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm" :disabled="sendding">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
  props: {
    ali_order_type: {
      type: Number,
      default: 0
    }
  },
  watch: {
    ali_order_type: {
      handler(newVal, oldVal) {
        console.log('ali_order_type changed from', oldVal, 'to', newVal);
        // 可以在这里添加你需要的逻辑处理
        this.current_id = null;
      },
      immediate: true // 在初始化时也执行监听器
    }
  },
  data() {
    return {
      current_id: null,
      buy_mode: 1,
      visible: false,
      list: [],
      params: {},
      func: {},
      callback: {},
      shop_id: null,
      sendding: false,
    }
  },
  mounted() {

  },
  methods: {
    ...mapActions({
      opPddAccountList: "ucenter_order/opPddAccountList",
    }),
    open(params, func, callback) {
      this.params = params;
      this.func = func;
      this.callback = callback
      this.visible = true;

      this.opPddAccountList({
        data: {
          page: 1,
          limit: 99999,
          group_ids: []
        },
        success: (res) => {
          this.list = res.data.data;
        }
      })
    },
    handlerConfirm() {
      if (this.sendding) {
        return;
      }
      this.sendding = true;
      this.func({
        data: Object.assign(this.params, {account_id: this.current_id, buy_mode: this.buy_mode}),
        success: (res) => {
          this.callback(res);
          this.visible = false;
          this.sendding = false;
        },
      })
    },
    handlerCancel() {
      this.visible = false;
    }
  }
}
</script>

<style scoped>

</style>
